export const cilFlagAlt = ["24 24","<path d='M21 2.625h-16.5v-1.875h-1.5v22.5h1.5v-6.375h16.5v-1.746l-3.945-5.379 3.945-5.379zM15.195 9.75l4.125 5.625h-14.82v-11.25h14.82z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-flag-alt.js
// module id = null
// module chunks = 